import { createContext, type ReactNode, useContext, useMemo, useState } from "react";


type Viewport = "desktop" | "mobile" | "code";


interface TemplatesEditorViewportContextType {
  viewport: Viewport;
  setViewport: (viewport: Viewport) => void;
}


const TemplatesEditorViewportContext = createContext<
  TemplatesEditorViewportContextType | undefined
>(undefined);


export interface TemplatesEditorViewportProviderProps {
  children: ReactNode;
}


export function TemplatesEditorViewportProvider({
  children,
}: TemplatesEditorViewportProviderProps) {
  const [viewport, setViewport] = useState<Viewport>("desktop");

  const value: TemplatesEditorViewportContextType = useMemo(
    () => ({
      viewport,
      setViewport,
    }),
    [viewport],
  );

  return (
    <TemplatesEditorViewportContext.Provider value={value}>
      {children}
    </TemplatesEditorViewportContext.Provider>
  );
}


export function useTemplatesEditorViewport() {
  const context = useContext(TemplatesEditorViewportContext);

  if (context === undefined) {
    throw new Error(
      "useEmailEditorViewport must be used within a EmailEditorViewportProvider",
    );
  }
  return context;
}
